export const ACTION_TYPES = {
  FINANCIAL_SITUATION_REQUEST: 'FINANCIAL_SITUATION_REQUEST',
  FINANCIAL_SITUATION_SUCCESS: 'FINANCIAL_SITUATION_SUCCESS',
  FINANCIAL_SITUATION_ERROR: 'FINANCIAL_SITUATION_ERROR'
}

const initialState = {
  data: {},
  isFetching: false,
  isFetched: false
}

export const financialSituationRequest = () => ({
  type: ACTION_TYPES.FINANCIAL_SITUATION_REQUEST
})

const financialSituation = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.FINANCIAL_SITUATION_REQUEST:
      return { ...state, isFetching: true }
    case ACTION_TYPES.FINANCIAL_SITUATION_SUCCESS:
      return {
        ...state,
        data: {
          balance: payload.data.value.patrimonialSituation,
          informed: payload.data.value.currentPatrimonialSituation,
          suggested: payload.data.value.suggestPatrimonialSituation,
          ...payload.data
        },
        isFetching: false,
        isFetched: true
      }
    default:
      return state
  }
}

export default financialSituation
